import api from "@/services/api.service";

export default {
  name: 'list-duplicate',
  components: {},
  props: {
    caption: {
      type: String,
      default: "Duplicate Contact List"
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      icon: 'fa fa-sort',
      selcol: '',
      search:'',
      items: [],
      items_merged: [],
      fields: [
      // { key: "#" },
      { key: "actions", stickyColumn: true },
      ],
      fieldsMerged: [],
      sech: {},
      currentPage: 1,
      currentMergedPage: 1,
      currentSortDir:'desc',        
      perPage: 10,
      perPageMerged: 10,
      totalRows: null,
      totalResponseContact: 0,
      totalMergedContact: 0,
      isBusy: true,
      delete_ids: [],
      process: false,
      allSelected: false,
      conflict_cnt:'',
      colName : '',
      noCollapse: false,
      merngedCnt:0,
      // pageOptionsMerged:[{
      //   text: '10', value: '10',
      // }, {
      //     text: '50', value: '50'
      // }, {
      //     text: '100', value: '100',
      // }, {
      //     text: '250', value: '250',
      // }, {
      //     text: '500', value: '500',
      // }],
    }
  },
  computed: {
    
  },
  mounted () {

  },
  watch: {
    currentPage: {
      handler: function(page) {         
          // this.getDuplicateContacts(page)
          this.toSort(this.sech.colName,page);
      }
    },
    // currentMergedPage: {
    //   handler: function(page) {         
    //       this.getMergedContacts(page)
    //   }
    // }
  },
  created() {
    this.getDuplicateContacts();
    this.toSort('conflict_score',1);
    // this.getMergedContacts()

  },
  methods: {
    makeToast(message = "", title = "Alert", variant = "warning") {
      this.toastCount++;
      this.$root.$bvToast.toast(message, {
        title: title,
        variant: variant,
        autoHideDelay: 3000
      });
    },  
    async getDuplicateContacts(page) {
      this.items = [];
      this.sech.page = page;
      this.sech.search = this.search;
      let response = await api.post("admin/duplicate-contact/list", this.sech);
      if (!response)
                this.makeToast("Something went to wrong please try again", "Alert", "danger", 6000);
            if (response.status == "success") {
              if (response.data.records.data != "") {  
                //GET ALL HEADERS FROM JSON        
                // var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.records.data[0].contact_data)]));
                var columns = response.data.header;    
                columns.splice(0,0);
                this.fields.push({key: 'conflict_score', label: 'Score', sortable: false})
                this.fields.push({key: 'status', label: 'Status', sortable: false})

                columns.map((h) => {
                 this.fields.push({key: h, sortable: false}) 
               });
                this.items = [];
               
                //Iterate Data 
                response.data.records.data.forEach( function(element) {                    
                  var someObject = Object.assign({}, JSON.parse(element.contact_data), {id:element.id,conflict_score:element.highScore,status:element.status} )
                  this.items.push(someObject);  
                }.bind(this));
        
                this.conflict_cnt = response.data.conflict_cnt;        
                this.totalResponseContact = response.data.records.total;        
                this.currentPage = response.data.records.current_page;
                this.perPage = response.data.records.per_page;
                this.pageOptions.forEach(element => {
                  if(element.value > this.totalResponseContact){
                    var indexOf = this.pageOptions.indexOf(element);
                    if( indexOf != 0 )
                    this.pageOptions.splice(indexOf)
                  }
                });
                if(this.totalResponseContact <= 500)
                this.pageOptions.push({text:'All',value:this.totalResponseContact});
              } else {
                this.items = [];
              }
            }
            this.isBusy = false;
    },
    // async getMergedContacts(page) {
    //   this.items_merged = [];
    //   this.sech.page = page;
    //   this.sech.paginateVal = this.perPageMerged; 
    //   let response = await api.post("admin/duplicate-contact/merged-contact-list", this.sech);
    //   if (response.status == "success") {
    //     if (response.data.records.data != "") {  
    //       var columns = response.data.header;    
      
    //       columns.map((h) => {
    //         this.fieldsMerged.push({key: h, sortable: true}) 
    //       });
    //       this.fieldsMerged.push({key: 'id', label: 'Id', sortable: true})
    //       response.data.records.data.forEach( function(element) {                    
    //           this.items_merged.push(element);  
    //       }.bind(this));
    //       this.totalMergedContact = response.data.records.total;
    //       this.currentMergedPage = response.data.records.current_page;
    //       this.perPageMerged = response.data.records.per_page;

    //       this.pageOptionsMerged.forEach(element => {
    //         if(element.value > this.totalMergedContact){
    //             var indexOf = this.pageOptionsMerged.indexOf(element);
    //             if( indexOf != 0 )
    //             this.pageOptionsMerged.splice(indexOf)
    //         }
    //       });
    //       if(this.totalMergedContact <= 500)
    //         this.pageOptionsMerged.push({text:'All',value:this.totalMergedContact});

    //     } else {
    //       this.items_merged = [];
    //     }
    //   }
    //   this.isBusy = false;
    // },
    async toSort (items,page = 1)
    {
        if (items != "actions") {                
            this.isBusy = true;
            if(page == 1)
            
            if(items == this.sech.colName)
            this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';  

            this.sech.sortType = this.currentSortDir;
            this.sech.colName = items;
            this.sech.page = page;
            this.sech.search = this.search;
            this.sech.paginateVal = this.perPage;

            let response = await api.post("admin/duplicate-contact/list", this.sech);
            if (!response)
                      this.makeToast("Something went to wrong please try again", "Alert", "danger", 6000);
                  if (response.status == "success") {
                    if (response.data.records.data != "") {  
                      if(this.currentSortDir == 'asc'){
                        this.icon1 = 'fa fa-sort-up';                             
                        this.selcol = items;        
                      } else{ 
                        this.icon1 = 'fa fa-sort-down';                             
                        this.selcol = items;
                      }

                      //GET ALL HEADERS FROM JSON        
                      var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.records.data[0].contact_data)]));
                      columns.splice(0,0);
                      this.fields.push({key: 'conflict_score', label: 'Score', sortable: false})
                      this.fields.push({key: 'status', label: 'Status', sortable: false})

                      columns.map((h) => {
                      this.fields.push({key: h, sortable: false}) 
                    });
                      this.items = [];
                    
                      //Iterate Data 
                      response.data.records.data.forEach( function(element) {                    
                        var someObject = Object.assign({}, JSON.parse(element.contact_data), {id:element.id,conflict_score:element.highScore,status:element.status} )
                        this.items.push(someObject);  
                      }.bind(this));
              
                      this.conflict_cnt = response.data.conflict_cnt;        
                      this.totalResponseContact = response.data.records.total;        
                      this.currentPage = response.data.records.current_page;
                      this.perPage = response.data.records.per_page;
                    } else {
                      this.items = [];
                    }
              }
            this.isBusy = false;
          }
    },
    async showConflict(id){    
      return this.$router.push({name : "Duplicate Contact Conflict",params: {conflict_id:id}});
    },
    confirmProcess(){
     this.$bvModal
     .msgBoxConfirm("Are you sure want to start de-duping process?")
     .then(value => {
       if (value) {
        this.$bvModal.msgBoxOk("You will get notified by email once the Dedup process has been completed. \n Please Refresh/Reload the page after successful notification", {
          title: 'Alert',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true})
         this.startProcess();
       } else {
         return;
       }
     })
     .catch(function() {
       return;
     });
    },
    async startProcess(){	
      this.items = [];  
      this.isBusy = true;
      this.process = true;
      let response = await api.post("admin/duplicate-contact/startProcess");
      if (!response)
            this.makeToast("Something went to wrong please try again", "Alert", "danger", 6000);
          if (response.status == "success") {
            this.process = false;
            this.getDuplicateContacts();            
            this.makeToast("Dedup process completed successfully", "Success", "success", 6000);
          }else {
            this.process = false;
            this.makeToast("Something went to wrong please try again", "Alert", "danger", 6000);
          }
      this.isBusy = false;
    },
    getRowCount(items) {    
      return items.length;
    },


  }
}


